import { useContext } from 'react'
import { Helmet } from 'react-helmet'
import DashboardContext from '../../Context'

/**
 * این کامپوننت برای مدیریت 
 * هدر های صفات است
 */
export default function HederHelmet() {

    const { urlpage, titlePage } = useContext(DashboardContext)
    return (
        <Helmet>
            <title>{`${titlePage} | داشبورد سرویک`}</title>
            <meta name='description' content={`${titlePage} | داشبورد سرویک`} />
            <link rel='canonical' href={`${urlpage}`} />
            <meta property="twitter:title" content={titlePage} />
            <meta property="twitter:description" content={`${titlePage} | داشبورد سرویک`} />
            <meta property="og:title" content={titlePage} />
            <meta property="og:description" content={`${titlePage} | داشبورد سرویک`} />
            <meta property="og:url" content={`${urlpage}`} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="fa-IR" />
        </Helmet>
    )
}